import UserVideoView from './UserVideoView';

export default UserVideoView;
